module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvYW5kcm9pZC1jaHJvbWUtNTEyeDUxMi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/android-chrome-512x512.png
// module id = a4un
// module chunks = 0